// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Eye = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Eye = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Eye = _exports.Eye = function Eye(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M10 3.889c-2.265 0-4.126 1.028-5.553 2.35C3.11 7.484 2.187 8.96 1.714 10c.473 1.042 1.396 2.517 2.73 3.76 1.43 1.323 3.291 2.351 5.555 2.351s4.125-1.028 5.552-2.35c1.337-1.244 2.26-2.72 2.733-3.761-.472-1.042-1.396-2.517-2.73-3.76-1.43-1.323-3.291-2.351-5.555-2.351M3.311 5.02C4.947 3.5 7.194 2.222 9.999 2.222s5.052 1.278 6.688 2.799c1.625 1.51 2.711 3.312 3.229 4.552.114.274.114.58 0 .854-.518 1.24-1.604 3.045-3.23 4.552-1.635 1.52-3.881 2.799-6.687 2.799-2.805 0-5.052-1.278-6.687-2.799C1.687 13.472.6 11.667.086 10.427a1.1 1.1 0 0 1 0-.854c.514-1.24 1.6-3.045 3.226-4.552m6.687 7.757a2.777 2.777 0 1 0 0-5.556h-.07A2.224 2.224 0 0 1 7.222 9.93V10A2.777 2.777 0 0 0 10 12.778m0-7.222a4.444 4.444 0 1 1 0 8.888 4.444 4.444 0 0 1 0-8.888"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "prefix__a"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M0 0h20v20H0z"
    }))));
  };
});
